import { ReactNode, useCallback, useMemo, useState } from "react"
import { useIntl } from "react-intl"
import styled, { useTheme } from "styled-components"
import { Window, HeadingBold, Icon, TertiaryCtaButton, WindowState, InvertTheme } from "slate-ui-components"

import { useMediaQuery } from "@react-hook/media-query"


interface ModeCallOutDialog {
	open: () => void
	close: () => void
	element: ReactNode
}


const Heading = styled(HeadingBold)`
	text-align: center;
`

const Body = styled.div`
	${({theme}) => theme.fonts.body1.normal};
	color: ${({theme}) => theme.colours.text.primary};
	padding-bottom: 30px;
	text-align: center;
`

const Underline = styled.u`
	text-decoration: underline;
  	text-decoration-color:rgb(240, 217, 13);
`

const ShareContentContainer  = styled.div<{$landscape: boolean}>`
	display: flex;
	flex-direction:  ${(p) => p.$landscape ? "column" : "column"};
	gap:7px;	
	align-items: stretch;
	align-self: center;
	max-width: 50vw
`

const CTAs = styled.div`
	display: flex;
	flex-flow: column nowrap;
	gap: 7px;
	align-items: stretch;
	justify-content: center;
	flex-grow: 1
`


export const useModeCallOutDialog = () : ModeCallOutDialog => {
	const intl = useIntl()
	
	
	const [windowState, updateWindowState] = useState<WindowState>("closed")	
	
	
	

	const theme = useTheme();
	const isFullScreenLayout = useMediaQuery(theme.breakpoints.fullScreenStream);


	const open = useCallback(() => {
			updateWindowState(prevState => prevState !== "open" ? "opening" : "open")			
		}, [])
		
		const close = useCallback(() => {
			updateWindowState(prevState => prevState !== "closed" ? "closing" : "closed")			
		}, [])
	
	

	const element = useMemo(() => {
		if(windowState === "closed") {
			return null;
		}
		

		const modeTitle = intl.formatMessage({id: "modeCallOut.title", defaultMessage: "SORRY FOR THE HOLD UP."})
		const modeMessage = intl.formatMessage({id: "modeCallOut.message", defaultMessage: "The Slate Maker is super busy <u>at the moment</u>. Because of this, features like color picker and camera rotation have been turned off temporarily. Stick around, you'll be able to use them soon."}, {u: (c) => <Underline>{c}</Underline>})		
		const modeCTA = intl.formatMessage({id: "modeCallOut.cta", defaultMessage: "OK, GOT IT!"})

		return (
			<InvertTheme>
				<Window state={windowState} updateState={updateWindowState} title={modeTitle}>					
					<Heading>
						{modeTitle}
					</Heading>
					<br/>
					<ShareContentContainer $landscape={isFullScreenLayout}>						
						<Body>
							{modeMessage}
						</Body>						
						<CTAs>
							<TertiaryCtaButton label={modeCTA} testId="mode-cta" onClick={close}>
								{modeCTA}
								<Icon icon="Check"/>
							</TertiaryCtaButton>						
						</CTAs>
					</ShareContentContainer>
				</Window>
			</InvertTheme>
		)
	}, [close, intl, windowState,isFullScreenLayout])

	return {
		open,
		close,
		element
	}
}